import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderAddLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFolderAddLeft"><Path d="M10.4014 3H2V12H7V15H10V20H22V6H12.4014L10.4014 3Z" fill="currentColor"/><Path d="M5.5 16.5V13.5H4V16.5H1V18H4V21H5.5V18H8.5V16.5H5.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolderAddLeft;
